var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, Timestamp, SubCollection, Collection } from '@1amageek/ballcap';
import { Base } from '.';
export class JobOffer extends Base {
    constructor() {
        super(...arguments);
        // ユーザーからの提出書類
        this.submitFromWorker = new Collection();
        // 求人レビュー投稿
        this.reviewPosts = new Collection();
        // 求人申請
        this.jobsApplied = new Collection();
    }
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('jobOffers');
    }
}
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "jobOfferId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "clinicId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "clinicName", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "clinicPlanType", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "clinicUserType", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "title", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "occupations", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "medicalDepartments", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "description", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "rewardTypeId", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "rewardAmount", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "payments", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "employmentId", void 0);
__decorate([
    Field,
    __metadata("design:type", Timestamp)
], JobOffer.prototype, "startWorkingTime", void 0);
__decorate([
    Field,
    __metadata("design:type", Timestamp
    // 交通費（有無）
    )
], JobOffer.prototype, "endWorkingTime", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], JobOffer.prototype, "isTransportationExpenses", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "recruitmentNumbers", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "remarks", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "belongings", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "submittedDocuments", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "applicationConditions", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "neededQualifications", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "jobRequirements", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "thumbnails", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], JobOffer.prototype, "documents", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "station", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "prefectureId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], JobOffer.prototype, "locationAddress", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "latitude", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "longitude", void 0);
__decorate([
    Field,
    __metadata("design:type", Timestamp
    // 募集可否
    )
], JobOffer.prototype, "offerDeadline", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], JobOffer.prototype, "isRecruitment", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], JobOffer.prototype, "isArchive", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], JobOffer.prototype, "isRegistered", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "jobAppliedCount", void 0);
__decorate([
    Field,
    __metadata("design:type", Number)
], JobOffer.prototype, "applyCheckedCount", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], JobOffer.prototype, "submitFromWorker", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], JobOffer.prototype, "reviewPosts", void 0);
__decorate([
    SubCollection,
    __metadata("design:type", Collection)
], JobOffer.prototype, "jobsApplied", void 0);
